module.exports = __webpack_public_path__ + "img/金烽数据魔方软件V1.0(1).c177ab69.png";